module.exports = __webpack_public_path__ + "static/media/securesky-dark.476eee6c.png";